import React from 'react'
import pageStyles from '../CreatorsProgramPage/styles.module.css'
import Text from '../../../Text'
import { $textPrimary, $textSecondary } from '../../../../styles/colors/semantics'
import Spacer from '../../../Spacer'
import SpecsTable from '../../Products/Utils/ItemSpecifications/SpecsTable'

function Step6() {
  return (
    <div className={pageStyles.stepWrapper}>
      <div className={pageStyles.stepContentWrapper}>
        <div className={pageStyles.stepTitle}>
          <Text type="heading-1">06</Text>
        </div>
        <div className={pageStyles.stepTextWrapper}>
          <Text type="heading-2" color={$textPrimary.dark}>Bonus cash rewards!</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>In addition to the regular rewards and benefits, the VRS Creators Program offers the opportunity to earn cash bonuses, making your participation even more rewarding. This bonus is designed to recognize and compensate the top-performing creators who go the extra mile in their content creation.</Text>
          <Spacer size={32}/>
          <SpecsTable specs={[
            { name: 'Views per video', value: 'Cash per Video', isItemName: true },
            { name: '0—1k', value: '$00.00' },
            { name: '1k—10k', value: '$15.00' },
            { name: '10k—100k', value: '$60.00' },
            { name: '100k—200k', value: '$120.00' },
            { name: '200k—500k', value: '$200.00' },
            { name: '500k—1m', value: '$250.00' },
            { name: '1m+', value: '$600.00' },
          ]} theme="dark"/>
          <Spacer size={32}/>
          <SpecsTable specs={[
            { name: 'Likes per Post', value: 'Cash per Post', isItemName: true },
            { name: '0—500', value: '$00.00' },
            { name: '500—1k', value: '$15.00' },
            { name: '1k—3k', value: '$60.00' },
            { name: '3k—5k', value: '$120.00' },
            { name: '5k+', value: '$250.00' },
          ]} theme="dark"/>
        </div>
      </div>
    </div>
  )
}

export default Step6
